(function () {
  'use strict';

  function disableAtcBtn() {
    document.querySelectorAll('button[name="add"],.m-add-to-cart').forEach(function (b) {
      b.setAttribute('disabled', '');
      b.classList.add('disabled');
      b.style.opacity = '0.5';
      b.style.pointerEvents = 'none';
      b.style.cursor = 'not-allowed';
    });
  }

  function enableAtcBtn() {
    document.querySelectorAll('button[name="add"],.m-add-to-cart').forEach(function (b) {
      b.removeAttribute('disabled');
      b.classList.remove('disabled');
      b.style.opacity = '';
      b.style.pointerEvents = '';
      b.style.cursor = '';
    });
  }

  function isPlayerFormComplete() {
    var teamInp = document.querySelector('input[name="properties[Team Name]"]');
    if (!teamInp || !teamInp.value.trim()) return false;
    var players = document.querySelectorAll('.player-field');
    if (!players.length) return false;
    for (var i = 0; i < players.length; i++) {
      var pl = players[i];
      var checked = pl.querySelector('input[type="radio"]:checked');
      if (!checked) return false;
      var isAdult = checked.value === 'adult';
      var sel = isAdult
        ? (pl.querySelector('.adult-size-select') || pl.querySelector('.asel'))
        : (pl.querySelector('.youth-size-select') || pl.querySelector('.ysel'));
      if (!sel || !sel.value) return false;
      var nameF = pl.querySelector('input[name*="Name"]');
      if (!nameF || !nameF.value.trim()) return false;
      var numF = pl.querySelector('.player-number-input') || pl.querySelector('.pnum') || pl.querySelector('.pn');
      if (!numF || !numF.value.trim()) return false;
    }
    return true;
  }

  function syncBtn() {
    if (isPlayerFormComplete()) { enableAtcBtn(); } else { disableAtcBtn(); }
  }

  disableAtcBtn();
  document.addEventListener('DOMContentLoaded', disableAtcBtn);
  setInterval(syncBtn, 300);
  document.addEventListener('change', syncBtn);
  document.addEventListener('input',  syncBtn);

  /* ── NUEVO: clave sessionStorage para modo Add More ── */
  var ADD_MORE_RESTORE_KEY = 'belt_add_more_restore';

  /* NUEVO: Parsear params URL cuando viene del boton Add More */
  function parseAddMoreParams() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('edit_mode') !== '1') return null;
    var state = {
      currentQty:    parseInt(params.get('current_qty') || '0', 10),
      solo:          {},
      players:       {},
      existingCount: parseInt(params.get('existing_players') || '0', 10)
    };
    params.forEach(function (value, key) {
      if (key.indexOf('prop_') === 0) state.solo[key.slice(5)] = value;
    });
    params.forEach(function (value, key) {
      var match = key.match(/^p(\d+)_(.+)$/);
      if (!match) return;
      var num = parseInt(match[1], 10);
      var field = match[2];
      if (!state.players[num]) state.players[num] = {};
      state.players[num][field] = value;
    });
    return state;
  }

  /* NUEVO: Determinar si un campo es de talla */
  function isSizeKey(key) {
    var l = key.toLowerCase();
    return l.indexOf('size') !== -1 || l.indexOf('talla') !== -1 || l.indexOf('tama') !== -1;
  }

  /* NUEVO: Determinar si una talla es de adulto */
  function isAdultSize(sizeValue) {
    return /adult/i.test(sizeValue);
  }

  /* NUEVO: Aplicar estado de un player a un elemento .player-field */
  function applyPlayerState(playerEl, playerData) {
    var nameVal = '', numberVal = '', sizeVal = '';
    Object.keys(playerData).forEach(function (key) {
      var lk = key.toLowerCase();
      if (lk.indexOf('name') !== -1)   nameVal   = playerData[key];
      if (lk.indexOf('number') !== -1) numberVal = playerData[key];
      if (isSizeKey(key))              sizeVal   = playerData[key];
    });
    var nameInput = playerEl.querySelector('[name*="Name"]') || playerEl.querySelector('input[placeholder*="name" i]');
    if (nameInput && nameVal) nameInput.value = nameVal;
    var numInput = playerEl.querySelector('.player-number-input') || playerEl.querySelector('.pnum') || playerEl.querySelector('.pn') || playerEl.querySelector('input[placeholder*="number" i]');
    if (numInput && numberVal) numInput.value = numberVal;
    if (sizeVal) {
      var adult      = isAdultSize(sizeVal);
      var adultRadio = playerEl.querySelector('input[value="adult"]');
      var youthRadio = playerEl.querySelector('input[value="youth"]');
      var adultSel   = playerEl.querySelector('.adult-size-select') || playerEl.querySelector('.asel');
      var youthSel   = playerEl.querySelector('.youth-size-select') || playerEl.querySelector('.ysel');
      var adultCont  = playerEl.querySelector('.adult-size-container') || playerEl.querySelector('.ac');
      var youthCont  = playerEl.querySelector('.youth-size-container') || playerEl.querySelector('.yc');
      if (adult && adultRadio) {
        adultRadio.checked = true;
        if (adultCont) adultCont.style.display = 'block';
        if (youthCont) youthCont.style.display = 'none';
        if (adultSel)  adultSel.value = sizeVal;
        adultRadio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (!adult && youthRadio) {
        youthRadio.checked = true;
        if (youthCont) youthCont.style.display = 'block';
        if (adultCont) adultCont.style.display = 'none';
        if (youthSel)  youthSel.value = sizeVal;
        youthRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  /* NUEVO: Restaurar formulario completo desde estado parseado */
  function restoreFormFromState(state) {
    Object.keys(state.solo).forEach(function (key) {
      var el = document.querySelector('input[name="properties[' + key + ']"]') ||
               document.querySelector('textarea[name="properties[' + key + ']"]') ||
               document.querySelector('select[name="properties[' + key + ']"]');
      if (el) el.value = state.solo[key];
    });
    var qtyInput = document.getElementById('custom-qty');
    if (qtyInput) {
      qtyInput.value = '1';
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var wrapper = document.getElementById('players-wrapper');
    if (!wrapper) return;
    var playerNums = Object.keys(state.players).map(Number).sort(function (a, b) { return a - b; });
    if (!playerNums.length) return;
    var attempts = 0, maxAttempts = 30;
    function tryRestore() {
      attempts++;
      var playerEls = wrapper.querySelectorAll('.player-field');
      if (playerEls.length < playerNums.length && attempts < maxAttempts) {
        var addBtn = document.getElementById('qty-plus') || document.querySelector('[data-add-player]') || document.querySelector('.add-player-btn');
        if (addBtn) addBtn.click();
        setTimeout(tryRestore, 150);
        return;
      }
      playerEls = wrapper.querySelectorAll('.player-field');
      playerNums.forEach(function (num, idx) {
        if (playerEls[idx]) applyPlayerState(playerEls[idx], state.players[num]);
      });
      /* Guardar contexto en sessionStorage para el intercept del ATC */
      try {
        sessionStorage.setItem(ADD_MORE_RESTORE_KEY, JSON.stringify({
          currentQty: state.currentQty,
          existingPlayers: playerNums.length
        }));
      } catch(e) {}
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
      showAddMoreBanner(state.currentQty, playerNums.length);
    }
    setTimeout(tryRestore, 400);
  }

  /* NUEVO: Banner informativo en la pagina del producto */
  function showAddMoreBanner(currentQty, existingPlayers) {
    var existing = document.getElementById('m-add-more-banner');
    if (existing) existing.remove();
    var banner = document.createElement('div');
    banner.id = 'm-add-more-banner';
    banner.style.cssText = 'background:#f0fdf4;border:2px solid #16a34a;border-radius:10px;padding:14px 18px;margin-bottom:18px;font-size:14px;color:#15803d;display:flex;align-items:flex-start;gap:10px;line-height:1.5';
    banner.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:1px"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
      + '<div>'
      + '<strong>Adding to your existing order</strong><br>'
      + 'Your previous order of <strong>' + currentQty + ' belt' + (currentQty !== 1 ? 's' : '') + '</strong> with <strong>' + existingPlayers + ' player' + (existingPlayers !== 1 ? 's' : '') + '</strong> has been removed from the cart. '
      + 'All ' + existingPlayers + ' player' + (existingPlayers !== 1 ? 's have' : ' has') + ' been pre-filled below. Add the new player(s), then click <strong>Add to Cart</strong> to save the complete updated order.'
      + '</div>';
    var refNode = document.getElementById('players-wrapper') || document.querySelector('[data-product-custom-field]') || document.querySelector('.m-product-info--wrapper');
    if (refNode && refNode.parentElement) refNode.parentElement.insertBefore(banner, refNode);
  }

  /* NUEVO: Limpiar sessionStorage Add More tras Add to Cart exitoso */
  function setupAddMoreCartIntercept() {
    var restoreRaw = null;
    try { restoreRaw = sessionStorage.getItem(ADD_MORE_RESTORE_KEY); } catch(e) {}
    if (!restoreRaw) return;
    /* La orden anterior ya fue eliminada por goToAddMore.
       Solo necesitamos limpiar el sessionStorage tras el ATC exitoso
       y quitar el banner — el carrito recibe la nueva orden directamente. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.getAttribute('action') !== '/cart/add') return;
      /* Limpiar antes de que el form haga submit normal */
      try { sessionStorage.removeItem(ADD_MORE_RESTORE_KEY); } catch(ex) {}
      var banner = document.getElementById('m-add-more-banner');
      if (banner) banner.remove();
      /* El submit sigue su curso normal — no se previene */
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    /* ── Persistencia de campos custom en sessionStorage (ORIGINAL) ── */
    var pageKey = window.location.pathname;
    function storageKey(n) { return 'customField_' + pageKey + '_' + n; }
    document.querySelectorAll('[data-product-custom-field] input,[data-product-custom-field] textarea,[data-product-custom-field] select').forEach(function (inp) {
      if (!inp.name) return;
      var saved = sessionStorage.getItem(storageKey(inp.name));
      if (saved !== null) inp.value = saved;
      inp.addEventListener('input',  function () { sessionStorage.setItem(storageKey(this.name), this.value); });
      inp.addEventListener('change', function () { sessionStorage.setItem(storageKey(this.name), this.value); });
    });

    /* ── Captura/restaura estado de players al cambiar variante (ORIGINAL) ── */
    var wrapper = document.getElementById('players-wrapper');
    if (wrapper) {
      var capturedState = {}, pendingRestore = false, restoreTimer = null;

      function capturePlayerState() {
        if (pendingRestore) return;
        Object.keys(capturedState).forEach(function (k) { delete capturedState[k]; });
        wrapper.querySelectorAll('.player-field').forEach(function (player, idx) {
          var i = idx + 1;
          capturedState[i] = {
            name:      (player.querySelector('[name*="Name"]') || {}).value || '',
            number:    (player.querySelector('.player-number-input') || player.querySelector('.pnum') || player.querySelector('.pn') || {}).value || '',
            sizeType:  (player.querySelector('input[value="adult"]') || {}).checked ? 'adult' : (player.querySelector('input[value="youth"]') || {}).checked ? 'youth' : '',
            adultSize: (player.querySelector('.adult-size-select') || player.querySelector('.asel') || {}).value || '',
            youthSize: (player.querySelector('.youth-size-select') || player.querySelector('.ysel') || {}).value || ''
          };
        });
        pendingRestore = true;
      }

      function restorePlayerState() {
        wrapper.querySelectorAll('.player-field').forEach(function (player, idx) {
          var i = idx + 1, state = capturedState[i];
          if (!state) return;
          var nameInput  = player.querySelector('[name*="Name"]');
          var numInput   = player.querySelector('.player-number-input') || player.querySelector('.pnum') || player.querySelector('.pn');
          var adultRadio = player.querySelector('input[value="adult"]');
          var youthRadio = player.querySelector('input[value="youth"]');
          var adultSel   = player.querySelector('.adult-size-select') || player.querySelector('.asel');
          var youthSel   = player.querySelector('.youth-size-select') || player.querySelector('.ysel');
          var adultCont  = player.querySelector('.adult-size-container') || player.querySelector('.ac');
          var youthCont  = player.querySelector('.youth-size-container') || player.querySelector('.yc');
          if (nameInput && state.name)   nameInput.value = state.name;
          if (numInput  && state.number) numInput.value  = state.number;
          if (state.sizeType === 'adult' && adultRadio) {
            adultRadio.checked = true;
            if (adultCont) adultCont.style.display = 'block';
            if (youthCont) youthCont.style.display = 'none';
            if (adultSel && state.adultSize) adultSel.value = state.adultSize;
            if (youthSel) youthSel.value = '';
            adultRadio.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (state.sizeType === 'youth' && youthRadio) {
            youthRadio.checked = true;
            if (youthCont) youthCont.style.display = 'block';
            if (adultCont) adultCont.style.display = 'none';
            if (youthSel && state.youthSize) youthSel.value = state.youthSize;
            if (adultSel) adultSel.value = '';
            youthRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        pendingRestore = false;
      }

      new MutationObserver(function () {
        if (!pendingRestore) return;
        clearTimeout(restoreTimer);
        restoreTimer = setTimeout(restorePlayerState, 30);
      }).observe(wrapper, { childList: true });

      var qtyPlus  = document.getElementById('qty-plus');
      var qtyMinus = document.getElementById('qty-minus');
      var qtyInput = document.getElementById('custom-qty');
      if (qtyPlus)  qtyPlus.addEventListener('click',  capturePlayerState, true);
      if (qtyMinus) qtyMinus.addEventListener('click',  capturePlayerState, true);
      if (qtyInput) {
        qtyInput.addEventListener('input',  capturePlayerState, true);
        qtyInput.addEventListener('change', capturePlayerState, true);
      }
    }

    /* ── NUEVO: Add More – leer params URL y restaurar si aplica ── */
    var addMoreState = parseAddMoreParams();
    if (addMoreState) restoreFormFromState(addMoreState);

    /* ── NUEVO: Limpiar sessionStorage tras Add to Cart en modo Add More ── */
    setupAddMoreCartIntercept();
  });

}());
